import { Place } from '../types/results.types';

export function hasUsableBusinessWebsite(placeOrWebsite?: Place | string | null): boolean {
  const website = typeof placeOrWebsite === 'string' ? placeOrWebsite : placeOrWebsite?.website;

  if (!website || website === 'None' || website.trim() === '') return false;

  try {
    const parsed = new URL(website.includes('://') ? website : `https://${website}`);
    const hostname = parsed.hostname.toLowerCase();
    if (!hostname) return false;
    if (hostname === 'bbb.org' || hostname.endsWith('.bbb.org')) return false;
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
